// Exclusao de um ou mais documentos.
//
// Sempre lista, mesmo para um so: a Lista tem selecao multipla, e ter dois caminhos — um para o
// card, outro para o lote — daria duas copias das mesmas validacoes.
//
// Como nas outras escritas da tela, a lista de vendedores permitidos nao vem daqui: quem resolve
// o escopo do usuario logado e o OrquestradorVendas.
export class ExcluirVendaRequest {
    public idsVenda: number[] = [];
}
